module.exports = __webpack_public_path__ + "img/mahsulot-3.11ccf52a.png";